import cn from "classnames";
import { DefaultTemplate } from "components/modal/templates";
import Loader from "components/shared/loader";
import { dateTimeToView, humanizedTimeDiff } from "helpers/date";
import React, { Fragment } from "react";
import { getBidPointVisits, setBidPointsVisits } from "sources/books/bids";

export default class ChangePointVisit extends DefaultTemplate {
    state = {
        visitData: [],
        visitDataLoaded: false,
        activeItemId: null,
    };

    componentDidMount() {
        getBidPointVisits(this.props.bidPointId).then((visitData) =>
            this.setState({ visitData, visitDataLoaded: true }),
        );
    }

    saveVisitItem = () => {
        if (!this.state.activeItemId) {
            return;
        }
        const { bidPointId } = this.props;
        return setBidPointsVisits({
            bidPointVisits: [{ id: bidPointId, bidPointEnterId: this.state.activeItemId }],
        }).then(() => this.close(false));
    };

    renderVisitItem = ({ id, isMobile, enterDate, leaveDate }) => {
        const cname = cn("b-visit__tr", {
            "b-visit__tr--active": this.state.activeItemId === id,
        });
        return (
            <div key={id} className={cname} onClick={() => this.setState({ activeItemId: id })}>
                <div className="b-visit__td b-visit__td--checkbox">
                    <div className="b-visit__checkbox" />
                </div>
                <div className="b-visit__td">{dateTimeToView(enterDate)}</div>
                <div className="b-visit__td">{dateTimeToView(leaveDate)}</div>
                <div className="b-visit__td">{humanizedTimeDiff(leaveDate, enterDate)}</div>
                <div className="b-visit__td">{isMobile ? "Телефон" : "Трекер"}</div>
            </div>
        );
    };

    renderBody = () => {
        if (!this.state.visitDataLoaded) {
            return <Loader />;
        }
        const btnCname = cn("btn btn-brand btn-sm", { disabled: !this.state.activeItemId });
        if (this.state.visitData.length === 0) {
            return <h5 className="text-center text-muted pb-4">Нет данных о посещении данной точки</h5>;
        }
        return (
            <Fragment>
                <div className="b-visit">
                    <div className="b-visit__list">
                        <div className="b-visit__tr bg-secondary">
                            <div className="b-visit__td b-visit__td--checkbox" />
                            <div className="b-visit__td">Время въезда</div>
                            <div className="b-visit__td">Время выезда</div>
                            <div className="b-visit__td">Продолжительность</div>
                            <div className="b-visit__td">Источник данных</div>
                        </div>
                        {this.state.visitData.map(this.renderVisitItem)}
                    </div>
                </div>
                <div className="b-visit__footer">
                    <div className="btn btn-secondary btn-sm mr-2" onClick={this.close.bind(this, false)}>
                        Отменить
                    </div>
                    <div className={btnCname} onClick={this.saveVisitItem}>
                        Сохранить
                    </div>
                </div>
            </Fragment>
        );
    };
}
